import { push } from 'react-router-redux';

export const NavigationActions = {
	Navigate: (route: string, surveyId?: number, subRoute?: string) => {
		let path = route;
		if (surveyId != null) {
			path += '/' + surveyId;
		}
		if (subRoute != null) {
			path += '/' + subRoute;
		}
		return push(path);
	},
};
